import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: false,
    serviceDrawer: false,
    currentMenu: "",
    mapPoint: [
      // 地图点位
      {
        x: "330px",
        y: "450px",
        building: "18号楼",
      },
      {
        x: "50px",
        y: "450px",
        building: "民福医院",
      },
      {
        x: "530px",
        y: "400px",
        building: "17号楼",
      },
      {
        x: "150px",
        y: "360px",
        building: "22号楼",
      },
      {
        x: "400px",
        y: "320px",
        building: "19号楼",
      },
      {
        x: "50px",
        y: "210px",
        building: "25号楼",
      },
      {
        x: "230px",
        y: "190px",
        building: "26号楼",
      },
      {
        x: "0px",
        y: "270px",
        building: "23号楼",
      },
      {
        x: "300px",
        y: "270px",
        building: "24号楼",
      },
      {
        x: "700px",
        y: "250px",
        building: "服务中心",
      },
      {
        x: "520px",
        y: "250px",
        building: "医疗中心",
      },
      {
        x: "410px",
        y: "140px",
        building: "西膳房",
      },
      {
        x: "580px",
        y: "130px",
        building: "29号楼",
      },
      {
        x: "730px",
        y: "120px",
        building: "30号楼",
      },
      {
        x: "920px",
        y: "130px",
        building: "31号楼",
      },
      {
        x: "850px",
        y: "80px",
        building: "32号楼",
      },
    ],
    manageData: {}, // 智慧管理数据
    nurseData: {}, // 智慧照护数据
    boardData: [], // 实时播报数据
    securityData: {}, // 智慧安防数据
    serviceData: {}, // 智慧服务数据
    communicationData: {}, // 智慧交流数据
    componentCallsData: {}, // 组件调用
    videodata: {},
  },
  getters: {},
  mutations: {
    setDrawer(state, drawer) {
      state.drawer = drawer;
    },
    setServiceDrawer(state, drawer) {
      state.serviceDrawer = drawer;
    },
    setCurrentMenu(state, currentMenu) {
      state.currentMenu = currentMenu;
    },
    SET_MANAGE_DATA(state, data) {
      state.manageData = data;
    },
    SET_NURSE_DATA(state, data) {
      state.nurseData = data;
    },
    SET_BOARD_DATA(state, data) {
      state.boardData = data;
    },
    SET_SECURITY_DATA(state, data) {
      state.securityData = data;
    },
    SET_SERVICE_DATA(state, data) {
      state.serviceData = data;
    },
    SET_COMMUNICATION_DATA(state, data) {
      state.communicationData = data;
    },
    SET_COMPONENT_CALLS_DATA(state, data) {
      state.componentCallsData = data;
    },
    SET_VIDEO_DATA(state, data) {
      state.videodata = data;
    },
  },
  actions: {
    async getManageData({ commit }) {
      const { data: res } = await Vue.prototype.$api.manage.bigScreeIPMI({
        branchId: 6627,
        statusMasterId: 0
      });
      commit("SET_MANAGE_DATA", res.data);
    },
    async getNurseData({ commit }) {
      const { data: res } = await Vue.prototype.$api.nurse.bigScreeIHS({
        branchId: 6627,
      });
      commit("SET_NURSE_DATA", res.data);
    },
    // 获取实时播报数据
    async getBoardData({ commit }) {
      const { data: res } = await Vue.prototype.$api.dataBorad.ssbbList({
        branchId: 6627,
      });
      commit("SET_BOARD_DATA", res.data);
    },
    // 智慧安防数据
    async getSecurityData({ commit }) {
      const { data: res } =
        await Vue.prototype.$api.security.intelligentSecurity({
          branchId: 6627,
        });
      commit("SET_SECURITY_DATA", res.data);
    },

    async getServiceData({ commit }, data) {
      let res = await Vue.prototype.$api.rightSideBar.bigScreenService(data);
      commit("SET_SERVICE_DATA", res);
    },
    async getCommunicationData({ commit }, data) {
      let res = await Vue.prototype.$api.rightSideBar.bigScreenTalk(data);
      commit("SET_COMMUNICATION_DATA", res);
    },

    // 组件调用
    async getComponentCallsData({ commit }, data) {
      let res = await Vue.prototype.$api.rightSideBar.componentCalls(data);
      commit("SET_COMPONENT_CALLS_DATA", res);
    },
    // 视频列表
    async getVideoData({ commit }, data) {
      let res = await Vue.prototype.$api.security.bigScreenVideo(data);
      commit("SET_VIDEO_DATA", res);
    },
  },
  modules: {},
});
